/* HPZ — store switching is plain links with ?hpz_stay=1 (see snippets/market-form.liquid and snippets/geo-guard.liquid). Nothing to run here. */
(function () { 'use strict'; })();
